<div class="fxRow fxRowCenter loading-overlay">
  <img src="./assets/image/img/shop/collection/loader.gif" class="loading-icon img-fluid">
</div>
